/**
 * Navigation primitives, kept out of `router.tsx`.
 *
 * A module that exports both components and plain functions defeats React Fast Refresh —
 * the dev server can no longer hot-swap the component without re-running the module, so it
 * falls back to a full reload and loses your state. Splitting the non-component exports
 * here keeps `router.tsx` component-only. See DECISIONS.md D41.
 */

export const NAVIGATION_EVENT = "efss:navigate";

export function navigate(to: string, { replace = false } = {}): void {
  if (to === window.location.pathname) return;
  if (replace) {
    window.history.replaceState({}, "", to);
  } else {
    window.history.pushState({}, "", to);
  }
  // pushState does not fire popstate, so tell our own listeners.
  window.dispatchEvent(new Event(NAVIGATION_EVENT));
}

/** True when a click should be left to the browser: new tab, new window, middle click. */
export function isModifiedClick(event: {
  defaultPrevented: boolean;
  button: number;
  metaKey: boolean;
  ctrlKey: boolean;
  shiftKey: boolean;
  altKey: boolean;
}): boolean {
  return (
    event.defaultPrevented ||
    event.button !== 0 ||
    event.metaKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey
  );
}
